var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 233,
    viewBox: "0 0 365 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1 9.5C3.66543 8.33362 6.36686 7.01313 50.485 2.59513C81.6535 -0.526077 115.969 6.34161 152.744 16.6267C177.106 23.4401 189.767 35.8008 199.177 46.6603C209.32 58.3644 211.009 74.6616 213.659 87.2971C216.141 99.1255 209.895 116.438 199.619 136.434C190.713 153.764 170.487 166.538 151.083 180.658C136.122 191.545 118.054 194.884 100.992 196.068C89.7295 196.85 80.8897 190.219 72.9461 182.293C65.2274 174.591 65.5327 160.795 66.3986 145.244C67.5872 123.896 80.7837 105.429 93.9935 91.6179C108.41 76.5457 126.713 67.6988 142.865 61.222C177.177 47.4634 209.153 61.7433 242.376 82.8437C256.293 91.6821 272.525 109.741 285.62 122.818C298.715 135.895 306.879 145.226 320.124 164.029C333.37 182.832 351.448 210.824 363.094 230.202M363.094 230.202C365.076 233.5 358.287 219.987 363.094 230.202Z",
    stroke: "#01CC0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "14 14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector2.140dfc6275c0836a5826d0e230c18af3.svg";
export { ForwardRef as ReactComponent };